// extracted by mini-css-extract-plugin
export default {"foldername":"twoDStyles_foldername__EjxEz","card":"twoDStyles_card__TOMwD","create_sec":"twoDStyles_create_sec__8KsEY","create_text":"twoDStyles_create_text__o0WAM"};